import React from "react";

import { FileDraftIcon } from "assets";
import { UTILITY_BILL_PAGE } from "../../route-consts";

export const UTILITY_BILL_FORM_VIEW = {
  ICON: <FileDraftIcon />,
  ABSOLUTE_PATH: UTILITY_BILL_PAGE.ABSOLUTE_PATH,
  PATH: "",
  TITLE: "Invoice data",
};

export const sitePeriodBlockedMessage = "The bill is for a site and time period that's already signed off or locked. Including this bill may cause finalized emission numbers to change";

export const anomalyTypes = {
  BILL_DATE_RANGE: "Date Range",
  FUTURE_DATE: "Date Range",
  MULTIPLE_UPLOAD: "Duplicate Upload",
  PREVIOUS_USAGE_ZERO: "Previous usage zero",
  LAST_THRESHOLD_EXCEEDED: "Usage | MoM",
  Y2Y_THRESHOLD_EXCEEDED: "Usage | YoY",
  SITE_PERIOD_BLOCKED: "Site Period Blocked",
  COST: "Cost",
};

export const anomalyTypesKeys = Object.keys(anomalyTypes);
export const anomalyTypesValues = Object.values(anomalyTypes);

export const DATES_VERIFICATION_ANOMALY = {
  anomalyType: "Dates Needs Additional Verification",
  messages: "The AI could only detect one date on the invoice. The bill period has been auto-filled using the collector's frequency and this single detected date.",
};
